export const manipulateWishList = (type, payload) => {
  return {
    type: type,
    payload: payload,
  };
};
